import { Container, Grid } from '@material-ui/core';
import animalApi from 'api/query/animal/animal-api';
import { GroupTrait } from 'api/query/animal/group-trait';
import Axios from 'axios';
import Accordion from 'components/accordion';
import LoadContainer from 'components/load-container';
import { PercentileHighlight } from 'components/percentile-tag';
import MiniTable from 'components/table/mini-table';
import React, { useEffect, useState } from 'react';
import { TraitGroupProps } from './trait-groups-props';
import './trait-groups.scss';

export const TraitGroups: React.FC<TraitGroupProps> = (props) => {
  const {
    id,
    db,
    subIndex,
    asbvIds,
  } = props;

  const [groupTraits, setGroupTraits] = useState<GroupTrait[]>([]);

  useEffect(() => {
    const source = Axios.CancelToken.source();
    const getTraitGroups = async () => {
      try {
        const groups = await animalApi.getTraitGroups(id, db, subIndex, asbvIds, source.token);
        setGroupTraits(groups);
      } catch (e) {
        source.cancel();
      }
    };
    getTraitGroups();
  }, [asbvIds, db, id, subIndex]);

  return (
    <Container className="sg-trait-groups">
      <LoadContainer loading={!groupTraits.length}>
        {groupTraits.map((groupTrait) => (
          <Grid
            key={groupTrait.id}
            container
          >
            <Accordion
              title={groupTrait.name}
              panelSummaryIcon={<img src={`/images/traits/group-trait-${groupTrait.id}.svg`} alt={groupTrait.name} />}
              enableFullScreenStickyHeader
            >
              <div className="row">
                <div className="trait-group">
                  {groupTrait.categories.map((groupTraitCategory) => (
                    <Grid
                      className="card-container"
                      key={groupTraitCategory.id}
                      item
                      xs={12}
                      sm={6}
                      md={3}
                    >
                      <h5>{groupTraitCategory.name}</h5>
                      <div className="card-container__table">
                        <MiniTable
                          headerLabels={['', 'ASBV', 'ACC.', 'PCTL.']}
                          traits={groupTraitCategory.traits}
                          percentileHighlights={{ top: PercentileHighlight.Top20, bottom: PercentileHighlight.BottomNone }}
                          showTraitColumn
                        />
                      </div>
                    </Grid>
                  ))}
                </div>
              </div>
            </Accordion>
          </Grid>
        ))}
      </LoadContainer>
    </Container>
  );
};

(TraitGroups as any).whyDidYouRender = true;
